import BoxState from '../../scripts/lib/box-state.js'

class MealPlanButton extends HTMLElement {
  #boxState
  #buttonEl
  #boundHandleClick
  #isProcessing = false

  constructor() {
    super()
    this.#boundHandleClick = (e) => this.#handleClick(e)
  }

  connectedCallback() {
    this.#boxState = BoxState.getInstance()

    this.#buttonEl = this.querySelector('button, a')
    this.#buttonEl?.addEventListener('click', this.#boundHandleClick)
  }

  disconnectedCallback() {
    this.#buttonEl?.removeEventListener('click', this.#boundHandleClick)
  }

  async #handleClick(event) {
    event.preventDefault()

    if (this.#isProcessing) {
      console.log('[MealPlanButton] Already processing, ignoring click')
      return
    }

    const { cartUrl, mealPlanUrl } = this.dataset

    const boxItems = this.#boxState.boxItems
    const hasBoxItems = Object.values(boxItems).some(item => item.quantity > 0)

    if (hasBoxItems) {
      console.log('[MealPlanButton] Box items exist, going to cart')
      window.location.href = cartUrl
      return
    }

    const pets = this.#boxState.petProfiles
    const hasPets = pets && pets.length > 0

    if (hasPets) {
      console.log('[MealPlanButton] No box items but pets exist, syncing and redirecting to cart')

      this.#isProcessing = true
      if (this.#buttonEl) {
        this.#buttonEl.disabled = true
      }

      const currentEmail = this.#boxState.getCurrentEmail()
      if (currentEmail) {
        await this.#boxState.syncPetsToFirebase()
      }

      window.location.href = cartUrl
      return
    }

    console.log('[MealPlanButton] No box items or pets, going to configured URL or cart')
    window.location.href = mealPlanUrl || cartUrl
  }
}

if (!customElements.get('meal-plan-button')) {
  customElements.define('meal-plan-button', MealPlanButton)
}

export default MealPlanButton
